__turbopack_context__.v({
  "CheckboxList": "group-tree-with-checkbox-list-module__UqqCla__CheckboxList",
  "Root": "group-tree-with-checkbox-list-module__UqqCla__Root",
});
